import { getRequestQueryKey } from '../../hooks/use_suspense_api'

export const getChatConfigurationRequestArgs = () => {
  const url = '/me/chat_configuration'

  return {
    url,
    data: {
      fields: {
        ChatConfiguration: [
          'allowed_file_extensions',
          'max_file_size_in_bytes',
          'max_attachments_per_message',
        ],
      },
    },
  }
}

export const getChatConfigurationQueryKey = () => {
  const requestArgs = getChatConfigurationRequestArgs()
  return getRequestQueryKey(requestArgs)
}
